/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { ISettingGroupDefinition } from "@nuance/hierarchical-settings-ui-domain";
import { IAdvancedViewState } from "./IAdvancedViewState";
import { CmdBuilder, IViewModel } from "@nuance/hap-components";

export class AdvancedViewCommands {
    constructor() {
        const cb = new CmdBuilder();
        const cmds = {
            definitionChange: cb.bindCmd(this.definitionChangedHandler)
        };

        this.Cmds = cmds;
        this.Reducer = cb.buildReducer<IAdvancedViewState>(cmds);
    }

    readonly Cmds;
    readonly Reducer;

    /////////////////////////////////////////////////////////////////
    // Command handlers
    /////////////////////////////////////////////////////////////////
    definitionChangedHandler = (state: IAdvancedViewState, definition: ISettingGroupDefinition) => {
        state.definition = definition;
        return state;
    };
}

type IAdvancedViewCmds = AdvancedViewCommands["Cmds"];

export type IAdvancedViewViewModel = IViewModel<IAdvancedViewState, IAdvancedViewCmds>;
